import { useMemo } from 'react'

import { ChartData } from 'chart.js'
import { format } from 'date-fns'
import { Line } from 'react-chartjs-2'

import { DATE_DAY_MONTH_SHORT_FORMAT } from 'constants/index'

import {
  getManualInterventionChartOptions,
  LINE_STYLE,
  MANUAL_INTERVENTION_CHART_HEIGHT,
  SERIES_DASH_PATTERNS,
} from './chartConfig'
import { ManualInterventionSeries } from './types'

interface Props {
  series: ManualInterventionSeries[]
  height?: number
}

export const ManualInterventionsChart = ({
  series,
  height = MANUAL_INTERVENTION_CHART_HEIGHT,
}: Props) => {
  // Own instance: chart.js mutates whatever options object it is handed.
  const options = useMemo(getManualInterventionChartOptions, [])

  const data = useMemo<ChartData<'line', number[], string>>(() => {
    const labels = (series.find((s) => s.daily.length > 0)?.daily ?? []).map((point) =>
      format(new Date(point.date), DATE_DAY_MONTH_SHORT_FORMAT),
    )

    return {
      labels,
      datasets: series.map((s, index) => ({
        ...LINE_STYLE,
        label: s.label,
        data: s.daily.map((point) => point.count),
        borderColor: s.color,
        backgroundColor: s.color,
        pointBackgroundColor: s.color,
        borderDash: SERIES_DASH_PATTERNS[index % SERIES_DASH_PATTERNS.length],
      })),
    }
  }, [series])

  return (
    <div style={{ height, position: 'relative' }}>
      <Line data={data} options={options} />
    </div>
  )
}
